export default function Contact() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-8 bg-background-50 rounded-xl border border-background-200/60">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-500/15 rounded-xl flex-shrink-0">
              <i className="ri-mail-send-line text-primary-400 text-xl"></i>
            </div>
            <div>
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-100">投稿与咨询</h2>
              <p className="text-foreground-500 text-sm mt-1">
                影片资源投稿、合作咨询或问题反馈，欢迎通过以下方式联系我们
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
            <a
              href="mailto:contact@bajiemovie.com"
              className="w-full sm:w-auto px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium text-sm rounded-lg transition-colors cursor-pointer text-center whitespace-nowrap"
            >
              <i className="ri-at-line mr-1.5"></i>发送邮件
            </a>
            <span className="text-foreground-500 text-sm">或添加运营微信：bajiemovie</span>
          </div>
        </div>
      </div>
    </section>
  );
}